export default __webpack_public_path__ + "static/logo-53db9e3864d33f46f7944b414455ddc3.png";